import { render, staticRenderFns } from "./configurarPagamento.vue?vue&type=template&id=f536f4d8&"
import script from "./configurarPagamento.vue?vue&type=script&lang=js&"
export * from "./configurarPagamento.vue?vue&type=script&lang=js&"
import style0 from "./configurarPagamento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports